module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-close.8524beb1.svg";